
import { defineComponent, reactive } from 'vue';
import { QrcodeStream } from 'vue-qrcode-reader';

export default defineComponent({
  name: 'QRCodeReader',

  components: {
    QrcodeStream,
  },

  setup(_, { emit }) {
    const state = reactive({
      initialized: false,
      result: '',
      error: '',
      isLoading: false,
    });

    const onDecode = (result: string) => {
      state.result = result;
      emit('decode', result);
    };

    const onInit = async (promise: Promise<any>) => {
      state.isLoading = true;
      state.error = '';

      try {
        console.log('before init');
        await promise;
        console.log('after init');

        // CS-4867 強制DOM描画更新
        setTimeout(() => {
          state.initialized = true;
          console.log('initialized');
        }, 100);
      } catch (error) {
        // 適切なエラー文言はブラッシュアップ期に
        // if (error.name === 'NotAllowedError') {
        //   state.error = 'ERROR: you need to grant camera access permisson';
        // } else if (error.name === 'NotFoundError') {
        //   state.error = 'ERROR: no camera on this device';
        // } else if (error.name === 'NotSupportedError') {
        //   state.error = 'ERROR: secure context required (HTTPS, localhost)';
        // } else if (error.name === 'NotReadableError') {
        //   state.error = 'ERROR: is the camera already in use?';
        // } else if (error.name === 'OverconstrainedError') {
        //   state.error = 'ERROR: installed cameras are not suitable';
        // } else if (error.name === 'StreamApiNotSupportedError') {
        //   state.error = 'ERROR: Stream API is not supported in this browser';
        // }

        state.error = 'カメラの起動に失敗しました。';
      } finally {
        state.isLoading = false;
      }
    };

    return {
      state,
      onDecode,
      onInit,
    };
  },
});
